export var SchemaEvolutionMode;
(function (SchemaEvolutionMode) {
    SchemaEvolutionMode["SCHEMA_EVOLUTION_MODE_STRICT"] = "strict";
    SchemaEvolutionMode["SCHEMA_EVOLUTION_MODE_BACKWARD_COMPATIBLE"] = "backward_compatible";
    SchemaEvolutionMode["SCHEMA_EVOLUTION_MODE_AUTO_UPDATE"] = "auto_update";
})(SchemaEvolutionMode || (SchemaEvolutionMode = {}));
